module.exports = __webpack_public_path__ + "img/absorbente14.2456678f.jpg";